module.exports = __webpack_public_path__ + "media/images/lb/079-fef3c917970b9e3f110001c700e2c3d3.svg";